import styled from "styled-components";
import { Input } from "antd";
const { TextArea } = Input;

export const AntTextArea = styled(TextArea)`
  &:hover {
    border-color: #ed6928 !important;
  }
`;
